import actionCreatorFactory from 'typescript-fsa';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { CustomerData } from '@shared/types/customer';
import { RootState } from '@client/redux/types';
import { getCustomer } from '@client/services/api/customer';

import { NAMESPACE } from './constants';
import { isCustomerFetching, isCustomerInitialized } from './selectors';
import { MyFilter } from './state';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const setPreferredCountry = actionCreator<string>('SET_PREFERRED_COUNTRY');

export const fetchCustomerAction = actionCreator.async<void, CustomerData, string>(
    'FETCH_CUSTOMER',
);

export const fetchingMyfilter = actionCreator.async<null, MyFilter, Error>('FETCH_MYFILTER');

export const updatingMyfilter = actionCreator.async<null, MyFilter, Error>('UPDATE_MYFILTER');

export const fetchCustomer =
    (ignoreInitialization?: boolean): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch, getState) => {
        const state = getState();
        const isFetching = isCustomerFetching(state);
        const isInitialized = isCustomerInitialized(state) && ignoreInitialization !== true;

        if (!isFetching && !isInitialized) {
            /**
             * Fetch customer information only when we do not have any concurrent request.
             * or
             * When the customer was not initialized successfully on the client side.
             */
            dispatch(fetchCustomerAction.started());

            try {
                const data = await getCustomer();

                dispatch(fetchCustomerAction.done({ result: data }));
            } catch (e) {
                dispatch(fetchCustomerAction.failed({ error: 'Fetching customer failed.' }));
            }
        }
    };
